export const defaultJsonContent = JSON.stringify({
  type: "doc",
  content: [{ type: "paragraph", attrs: {} }],
})
